import { db } from './schema';

export async function getSetting<T>(key: string): Promise<T | undefined> {
  const row = await db.settings.get(key);
  return row === undefined ? undefined : (row.value as T);
}

export async function setSetting(key: string, value: unknown): Promise<void> {
  await db.settings.put({ key, value });
}

const PERSIST_ASKED = 'storage.persistAsked';

/**
 * Asked once, on first run, so the webview doesn't evict the database under
 * storage pressure — everything the user has is in there and none of it is
 * recoverable from a server.
 *
 * A denial is remembered rather than re-requested every launch.
 *
 * Nothing reads the answer back. Settings used to report it, and the report
 * was removed: the only thing it could tell you to do was make a backup, which
 * that screen already says without the alarm.
 */
export async function requestPersistentStorage(): Promise<void> {
  if (navigator.storage?.persist === undefined) return;
  if (await navigator.storage.persisted()) return;
  if ((await getSetting<boolean>(PERSIST_ASKED)) === true) return;

  await setSetting(PERSIST_ASKED, true);
  await navigator.storage.persist();
}
